module.exports = __webpack_public_path__ + "img/03.04c497ec.png";